<template>
    <v-container>
        <v-divider></v-divider>
        <v-row >
            <v-col class="mx-10" cols="2">
                <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="date"
                            label="เดือนที่แสดงข้อมูล"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="date"
                        type="month"
                        no-title
                        :show-current="false"
                        @change="reload()"
                        scrollable
                    >
                        <v-spacer></v-spacer>
                        <v-btn
                            text
                            color="primary"
                            @click="menu = false"
                        >
                            Cancel
                        </v-btn>
                        <v-btn
                            text
                            color="primary"
                            @click="$refs.menu.save(date)"
                        >
                            OK
                        </v-btn>
                    </v-date-picker>
                </v-menu>
            </v-col>
            <v-spacer></v-spacer>
            <v-col class="mx-10" cols="2">
                <v-btn tile style="color:white" color="green" @click="csvExport()">
                    <v-icon left>mdi-table-arrow-down</v-icon>Export CSV
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="mx-10" >
                <v-data-table
                :headers="headers"
                :items="desserts"
                :items-per-page="100"
                class="elevation-1"
            >
            </v-data-table>
            </v-col>
            
        </v-row>
          
    </v-container>
  
</template>


<script>
import config from '@/../config.js'
import Staff from '@/model/instance/Staff.js'
import axios from 'axios';


import Constant from '@/model/utils/Constants.js'
export default {
    props: ["station_code"],
    name: "ReportAppointment",
    data: () => ({
        date: new Date().toISOString().substr(0, 7),
        menu: false,
        groups: Constant.groups,
        headers: [
                {text: 'วันที่', value: 'date'},
                {text: 'จำนวนนัดหมายวันนี้', value: 'col1' ,align: 'center'},
                {text: 'มาตรงเวลา', value: 'col2' ,align: 'right'},
                {text: '', value: 'col3' ,align: 'left'},
                {text: 'มาก่อนเวลา', value: 'col4' ,align: 'right'},
                {text: '', value: 'col5' ,align: 'left'},
                {text: 'มาหลังเวลา', value: 'col6' ,align: 'right'},
                {text: '', value: 'col7' ,align: 'left'},
                {text: 'ไม่มาตามนัด', value: 'col8' ,align: 'right'},
                {text: '', value: 'col9' ,align: 'left'}
            ],
        desserts: [],
        report_duedate : null
    }),
    mounted : function () {
        var que = this.$store.commit('addLoading')
        axios.post(
            config.api.url.manage.customer.customerbystationcode ,
            {station_code:this.station_code},
            { headers: Staff.getTokenHeader()}
        ).then(rs => {
            this.$store.commit('finishLoading',que)
            this.report_duedate = rs.data.report_duedate
            this.reload()
        });
    },
    methods: {
        reload(){
            var que = this.$store.commit('addLoading')

            var start_date = this.date.substring(0,4) + '-' + this.date.substring(5,7) + '-01'
            var d = new Date(start_date)
            d.setHours(d.getHours()+7)
            d.setMonth(d.getMonth()+1)
            d.setDate(d.getDate()-1)
            var end_date = d.toISOString().substring(0,10)

            if(this.report_duedate && this.report_duedate != null && this.report_duedate > 0){
                var duedate = '00' + this.report_duedate
                duedate = duedate.substring(duedate.length-2,duedate.length)
                end_date = this.date.substring(0,4) + '-' + this.date.substring(5,7) + '-' + duedate
                var d2 = new Date(end_date)
                d2.setHours(d2.getHours()+7)
                d2.setMonth(d2.getMonth()-1)
                d2.setDate(d2.getDate()+1)
                start_date = d2.toISOString().substring(0,10)
            }

            axios
            .post(config.api.url.manage.dashboard.get_activatestat,{
                station_code : this.station_code
                ,start_date : start_date
                ,end_date : end_date
            },{ headers: Staff.getTokenHeader()}
            ).then(response => {
                this.desserts = []
                response.data.forEach(r => {
                    var d = new Date(r.date)
                    d.setHours(d.getHours()+7)
                    this.desserts.push(
                        {
                            'date': d.toISOString().substring(0,10),
                            'col1': r.cnt_all, 
                            'col2': r.cnt_ontime, 
                            'col3': r.cnt_ontime == 0 ? '' : ((r.cnt_ontime*100/r.cnt_all).toFixed(1) + '%'), 
                            'col4': r.cnt_before, 
                            'col5': r.cnt_before == 0 ? '' : ((r.cnt_before*100/r.cnt_all).toFixed(1) + '%'), 
                            'col6': r.cnt_after,
                            'col7': r.cnt_after == 0 ? '' : ((r.cnt_after*100/r.cnt_all).toFixed(1) + '%'), 
                            'col8': r.cnt_noshow, 
                            'col9': r.cnt_noshow == 0 ? '' : ((r.cnt_noshow*100/r.cnt_all).toFixed(1) + '%'), 
                        }
                    )
                });
                this.$store.commit('finishLoading',que)
            }).catch(error => {
                this.$router.push({name:'Error',params:error}) 
            })
        },
        csvExport() {
            let csvContent = "data:text/csv;charset=utf-8," + "\ufeff";
            csvContent += [
                this.headers.map(h=>h.text).join(","),
                ...this.desserts.map(item => Object.values(item).join(","))
            ].join("\n");
            const data = encodeURI(csvContent);
            const link = document.createElement("a");
            link.setAttribute("href", data);
            link.setAttribute("download", "report_activatebehavior_" + this.date.substring(0,4) + '-' + this.date.substring(5,7) + ".csv");
            link.click();
        }
    }
}
</script>